import { FlightFragment } from '@websky/graphql';

export const getFlightWithSegmentGroup = (
	flight: FlightFragment,
	group: FlightFragment['segmentGroups'][0],
	subsidized?: boolean
) => {
	return {
		id: flight.id,
		segments: group.segments.map(segment => flight.segments[segment.id]),
		pricesForFareGroups: [
			{
				fareFamily: group.fareFamily
					? {
							...group.fareFamily
					  }
					: null,
				prices: [
					{
						originalPrice: group.price,
						price: group.price,
						priceInMiles: group.priceInMiles,
						flight: {
							fares: [] as any,
							canBePaidByMiles: false,
							id: flight.id,
							subsidized
						}
					}
				]
			}
		]
	};
};
